/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { LoginRequestAccount } from './loginRequestAccount';
import { SignupOrganizationRequestOrganization } from './signupOrganizationRequestOrganization';

export interface SignupOrganizationRequest { 
    account: LoginRequestAccount;
    organization: SignupOrganizationRequestOrganization;
    timezone?: string;
}